import { Component } from '@angular/core';
import { PageContent } from '../../shared/page-content/page-content.component';
import { ServiceCard } from "./service-card/service-card.component";
import { NgOptimizedImage } from '@angular/common';

@Component({
  selector: 'app-services',
  imports: [PageContent, ServiceCard, NgOptimizedImage],
  templateUrl: './services.component.html',
  styleUrl: './services.component.scss',
})
export class Services {

}
